<div class="container">
  <ui-page-template [bgBlue]="true" [showFooter]="true">
    <div slot="content" class="content">
      <app-not-found></app-not-found>
    </div>
  </ui-page-template>
</div>
